import React from "react";
import "../assets/css/recursos.css";
import recursosHumanos from "../assets/img/recursosHumanos.jpg";
import recursosMateriales from "../assets/img/recursosMateriales.jpg";

const Recursos = () => {
  return (
    <div className="contenedor-recursos">
      <div className="contenedor-personal">
        <div className="personalMaterial">
          <h2>Contamos con Personal y Material preparado</h2>
          <p>Conoce nuestros recursos</p>
        </div>
      </div>

      <div className="contenedor-recursos-humanos">
        <h2>Recursos Humanos</h2>
        <section className="seccion-recursos">
          <div className="contenido-seccion1 ">
            <article className="texto-seccion">
              <p>
                Porque en nuestra firma el material humano es el factor
                preponderante para la prestación de un servicio eficaz y
                eficiente para nuestros clientes, contamos con la participación
                profesional de socios y asociados de amplia experiencia y
                reconocido prestigio en sus especialidades (abogados,
                contadores, economistas), quienes caracterizan a nuestra Firma
                por su alto nivel profesional, la lealtad y el respeto a los
                intereses de nuestros clientes, sirviéndoles de guía para una
                correcta toma de decisiones, a fin de prevenir cualquier tipo de
                conflictos, y aportando soluciones efectivas y rentables a los
                conflictos ya generados, permitiendo a su empresa el desarrollo
                fluido de sus actividades. Asimismo, como soporte para consultas
                específicas, según sea necesario, contamos con la colaboración
                de reconocidos consultores nacionales, con quienes a su vez
                colaboramos en distintas áreas.
              </p>
            </article>
            <figure className="imagen-seccion1">
              <img src={recursosHumanos} alt="Imagen de Recursos Humanos" />
              <div className="recursos-humanos-texto">
                <p>Recursos Humanos</p>
              </div>
            </figure>
          </div>
        </section>

        <h2>Recursos Materiales</h2>
        <section className="seccion-recursos">
          <div className="contenido-seccion2">
            <figure className="imagen-seccion2">
              <img
                src={recursosMateriales}
                alt="Imagen de Recursos Materiales"
              />
              <div className="recursos-humanos-texto2">
                <p>Recursos Materiales</p>
              </div>
            </figure>
            <article className="texto-seccion2">
              <p>
                Nuestra firma tiene presencia en Lima, Trujillo y Piura, con
                actividades extendidas a Chiclayo y Cajamarca. Contamos con
                tecnología avanzada, incluyendo un sistema propio para el
                seguimiento de gestiones, lo que permite a nuestros clientes
                acceder a información clara y actualizada sobre sus casos. A
                través de nuestra página web, ofrecemos un sistema de monitoreo
                en línea, disponible las 24 horas, donde los clientes pueden
                revisar el estado de sus procesos judiciales o gestiones
                extrajudiciales desde cualquier lugar, utilizando un nombre de
                usuario y clave. Estamos siempre conectados para brindar un
                servicio ágil y transparente.
              </p>
            </article>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Recursos;
